import { makeStyles } from 'tss-react/mui';
import { spacing } from '../../styles/jss/variables';
const MAX_WIDTH_INNER = 520;
const MAX_WIDTH_OUTER = 782;
const useStyles = makeStyles()((theme) => ({
    container: {},
    innerContainer: {
        margin: '0 auto',
        maxWidth: MAX_WIDTH_INNER,
        '& p:first-of-type': {
            marginBottom: 0,
        },
    },
    input: { marginBottom: spacing.large },
    error: { marginBottom: spacing.small },
    buttons: {},
    modal: {
        '& .MuiDialog-container': {
            alignItems: 'flex-start',
            [theme.breakpoints.up('sm')]: {
                alignItems: 'center',
            },
        },
        '& .MuiPaper-root': {
            height: '100vh',
            margin: 0,
            width: '100vw',
            maxWidth: MAX_WIDTH_OUTER,
            padding: spacing.medium,
            [theme.breakpoints.up('sm')]: {
                height: 'auto',
                padding: spacing.xl,
                paddingBottom: spacing.xxl,
                width: '100%',
            },
        },
    },
}));
export default useStyles;
